<template>
    <div>
        <BaseEchart :option="option" :width="width" :height="height"></BaseEchart>
    </div>
</template>


<script>
import BaseEchart from '@/components/base-echart/base-echart.vue';
export default {
    components: {
        BaseEchart,
    },
    props: {
        xData: {
            type: Array,
        },
        values: {
            type: Array,
        },
        width: {
            type: String,
            default: "100%",
        },
        height: {
            type: String,
            default: "350px",
        },
    },
    computed: {
        option() {
            console.log('this.values', this.values)
            return {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: this.values.map(item => item.name),
                    x:'right'
                },
                toolbox: {
                    show: true,
                    orient: 'vertical',
                    left: 'right',
                    top: 'center'
                },
                xAxis: [
                    {
                        type: 'category',
                        axisTick: { show: false },
                        data: this.xData,
                        axisLabel: {
                            interval: 0,//代表显示所有x轴标签显示
                            // rotate: 45, //代表逆时针旋转45度
                            formatter: function (params) {
                                var newParamsName = "";
                                var paramsNameNumber = params.length;
                                var provideNumber = 5; //一行显示几个字
                                var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                                if (paramsNameNumber > provideNumber) {
                                    for (var p = 0; p < rowNumber; p++) {
                                        var tempStr = "";
                                        var start = p * provideNumber;
                                        var end = start + provideNumber;
                                        if (p == rowNumber - 1) {
                                            tempStr = params.substring(start, paramsNameNumber);
                                        } else {
                                            tempStr = params.substring(start, end) + "\n";
                                        }
                                        newParamsName += tempStr;
                                    }
                                } else {
                                    newParamsName = params;
                                }
                                return newParamsName;
                            }
                        },

                        // data: ['2012', '2013', '2014', '2015', '2016']
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: this.values
            };
        }
    }
}
</script>